import { MEASUREMENTS_UNITS } from '../constants';

const { IMPERIAL, METRIC } = MEASUREMENTS_UNITS;

export const BRA_SIZE_CALCULATION_TABLE = [
  {
    cups: [
      {
        [IMPERIAL]: '6 1/2',
        [METRIC]: '16',
        results: {
          alpha: 'XS',
          hybrid: 'XS (A-C)',
        },
      },
      {
        [IMPERIAL]: '7',
        [METRIC]: '17',
        results: {
          alpha: 'XS',
          hybrid: 'XS (A-C)',
        },
      },
      {
        [IMPERIAL]: '7 1/2',
        [METRIC]: '19',
        results: {
          alpha: 'XS',
          hybrid: 'XS (A-C)',
        },
      },
      {
        [IMPERIAL]: '8',
        [METRIC]: '20',
        results: {
          alpha: 'XS',
          hybrid: 'XS (D-E)',
        },
      },
      {
        [IMPERIAL]: '9',
        [METRIC]: '22',
        results: {
          alpha: 'XS',
          hybrid: 'XS (D-E)',
        },
      },
      {
        [IMPERIAL]: '9 1/2',
        [METRIC]: '24',
        results: {
          hybrid: 'XS (F-G)',
        },
      },
      {
        [IMPERIAL]: '10',
        [METRIC]: '25',
        results: {
          hybrid: 'XS (F-G)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '25 - 26',
      [METRIC]: '63 - 66',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '7',
        [METRIC]: '17',
        results: {
          alpha: 'XS',
          hybrid: 'XS (A-C)',
        },
      },
      {
        [IMPERIAL]: '7 1/2',
        [METRIC]: '19',
        results: {
          alpha: 'XS',
          hybrid: 'XS (A-C)',
        },
      },
      {
        [IMPERIAL]: '8',
        [METRIC]: '20',
        results: {
          alpha: 'S',
          hybrid: 'S (A-C)',
        },
      },
      {
        [IMPERIAL]: '9',
        [METRIC]: '22',
        results: {
          alpha: 'S',
          hybrid: 'S (C-E)',
        },
      },
      {
        [IMPERIAL]: '9 1/2',
        [METRIC]: '24',
        results: {
          alpha: 'S',
          hybrid: 'S (C-E)',
        },
      },
      {
        [IMPERIAL]: '10',
        [METRIC]: '25',
        results: {
          hybrid: 'S (F-G)',
        },
      },
      {
        [IMPERIAL]: '11',
        [METRIC]: '27',
        results: {
          hybrid: 'S (F-G)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '26 1/2 - 28',
      [METRIC]: '67 - 71',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '7 1/2',
        [METRIC]: '19',
        results: {
          alpha: 'S',
          hybrid: 'S (A-C)',
        },
      },
      {
        [IMPERIAL]: '8',
        [METRIC]: '20',
        results: {
          alpha: 'S',
          hybrid: 'S (A-C)',
        },
      },
      {
        [IMPERIAL]: '9',
        [METRIC]: '22',
        results: {
          alpha: 'S',
          hybrid: 'S (C-E)',
        },
      },
      {
        [IMPERIAL]: '9 1/2',
        [METRIC]: '24',
        results: {
          alpha: 'M',
          hybrid: 'M (C-E)',
        },
      },
      {
        [IMPERIAL]: '10',
        [METRIC]: '25',
        results: {
          alpha: 'M',
          hybrid: 'M (C-E)',
        },
      },
      {
        [IMPERIAL]: '11',
        [METRIC]: '27',
        results: {
          hybrid: 'M (F-G)',
        },
      },
      {
        [IMPERIAL]: '11 1/2',
        [METRIC]: '29',
        results: {
          hybrid: 'M (F-G)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '28 1/2 - 30',
      [METRIC]: '72 - 76',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '8',
        [METRIC]: '20',
        results: {
          alpha: 'M',
          hybrid: 'M (A-B)',
        },
      },
      {
        [IMPERIAL]: '9',
        [METRIC]: '22',
        results: {
          alpha: 'M',
          hybrid: 'M (A-B)',
        },
      },
      {
        [IMPERIAL]: '9 1/2',
        [METRIC]: '24',
        results: {
          alpha: 'M',
          hybrid: 'M (C-E)',
        },
      },
      {
        [IMPERIAL]: '10',
        [METRIC]: '25',
        results: {
          alpha: 'L',
          hybrid: 'L (C-E)',
        },
      },
      {
        [IMPERIAL]: '11',
        [METRIC]: '27',
        results: {
          alpha: 'L',
          hybrid: 'L (C-E)',
        },
      },
      {
        [IMPERIAL]: '11 1/2',
        [METRIC]: '29',
        results: {
          hybrid: 'L (F-G)',
        },
      },
      {
        [IMPERIAL]: '12 1/2',
        [METRIC]: '31',
        results: {
          hybrid: 'L (F-G)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '30 1/2 - 32 1/2',
      [METRIC]: '77 - 83',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '9',
        [METRIC]: '22',
        results: {
          alpha: 'L',
          hybrid: 'L (A-B)',
        },
      },
      {
        [IMPERIAL]: '9 1/2',
        [METRIC]: '24',
        results: {
          alpha: 'L',
          hybrid: 'L (A-B)',
        },
      },
      {
        [IMPERIAL]: '10',
        [METRIC]: '25',
        results: {
          alpha: 'L',
          hybrid: 'L (C-E)',
        },
      },
      {
        [IMPERIAL]: '11',
        [METRIC]: '27',
        results: {
          alpha: 'XL',
          hybrid: 'XL (C-E)',
        },
      },
      {
        [IMPERIAL]: '11 1/2',
        [METRIC]: '29',
        results: {
          alpha: 'XL',
          hybrid: 'XL (C-E)',
        },
      },
      {
        [IMPERIAL]: '12 1/2',
        [METRIC]: '31',
        results: {
          hybrid: 'XL (F-G)',
        },
      },
      {
        [IMPERIAL]: '13',
        [METRIC]: '32',
        results: {
          hybrid: 'XL (F-G)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '33 - 35 1/2',
      [METRIC]: '84 - 90',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '9 1/2',
        [METRIC]: '24',
        results: {
          alpha: 'XL',
          hybrid: 'XL (A-B)',
        },
      },
      {
        [IMPERIAL]: '10',
        [METRIC]: '25',
        results: {
          alpha: 'XL',
          hybrid: 'XL (A-B)',
        },
      },
      {
        [IMPERIAL]: '11',
        [METRIC]: '27',
        results: {
          alpha: 'XL',
          hybrid: 'XL (C-E)',
        },
      },
      {
        [IMPERIAL]: '11 1/2',
        [METRIC]: '29',
        results: {
          alpha: '2XL',
          hybrid: '2XL (C-E)',
        },
      },
      {
        [IMPERIAL]: '12 1/2',
        [METRIC]: '31',
        results: {
          alpha: '2XL',
          hybrid: '2XL (C-E)',
        },
      },
      {
        [IMPERIAL]: '13',
        [METRIC]: '32',
        results: {
          hybrid: '2XL (F-G)',
        },
      },
      {
        [IMPERIAL]: '13 1/2',
        [METRIC]: '34',
        results: {
          hybrid: '2XL (F-G)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '36 - 38 1/2',
      [METRIC]: '91 - 98',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '10',
        [METRIC]: '25',
        results: {
          alpha: '2XL',
          hybrid: '2XL (A-B)',
        },
      },
      {
        [IMPERIAL]: '11',
        [METRIC]: '27',
        results: {
          alpha: '2XL',
          hybrid: '2XL (A-B)',
        },
      },
      {
        [IMPERIAL]: '11 1/2',
        [METRIC]: '29',
        results: {
          alpha: '2XL',
          hybrid: '2XL (C-E)',
        },
      },
      {
        [IMPERIAL]: '12 1/2',
        [METRIC]: '31',
        results: {
          alpha: '1X',
          hybrid: '1X (C-E)',
        },
      },
      {
        [IMPERIAL]: '13',
        [METRIC]: '32',
        results: {
          alpha: '1X',
          hybrid: '1X (C-E)',
        },
      },
      {
        [IMPERIAL]: '13 1/2',
        [METRIC]: '34',
        results: {
          hybrid: '1X (F-G)',
        },
      },
      {
        [IMPERIAL]: '14',
        [METRIC]: '36',
        results: {
          hybrid: '1X (F-G)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '39 - 41 1/2',
      [METRIC]: '99 - 105',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '11',
        [METRIC]: '27',
        results: {
          alpha: '1X',
          hybrid: '1X (A-B)',
        },
      },
      {
        [IMPERIAL]: '11 1/2',
        [METRIC]: '29',
        results: {
          alpha: '1X',
          hybrid: '1X (A-B)',
        },
      },
      {
        [IMPERIAL]: '12 1/2',
        [METRIC]: '31',
        results: {
          alpha: '1X',
          hybrid: '1X (C-E)',
        },
      },
      {
        [IMPERIAL]: '13',
        [METRIC]: '32',
        results: {
          alpha: '2X',
          hybrid: '2X (C-E)',
        },
      },
      {
        [IMPERIAL]: '13 1/2',
        [METRIC]: '34',
        results: {
          alpha: '2X',
          hybrid: '2X (C-E)',
        },
      },
      {
        [IMPERIAL]: '14',
        [METRIC]: '36',
        results: {
          hybrid: '2X (F-G)',
        },
      },
      {
        [IMPERIAL]: '15',
        [METRIC]: '37',
        results: {
          hybrid: '2X (F-G)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '42 - 44 1/2',
      [METRIC]: '106 - 113',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '11 1/2',
        [METRIC]: '29',
        results: {
          alpha: '2X',
          hybrid: '2X (A-B)',
        },
      },
      {
        [IMPERIAL]: '12 1/2',
        [METRIC]: '31',
        results: {
          alpha: '2X',
          hybrid: '2X (A-B)',
        },
      },
      {
        [IMPERIAL]: '13',
        [METRIC]: '32',
        results: {
          alpha: '2X',
          hybrid: '2X (C-E)',
        },
      },
      {
        [IMPERIAL]: '13 1/2',
        [METRIC]: '34',
        results: {
          alpha: '3X',
          hybrid: '3X (C-E)',
        },
      },
      {
        [IMPERIAL]: '14',
        [METRIC]: '36',
        results: {
          alpha: '3X',
          hybrid: '3X (C-E)',
        },
      },
      {
        [IMPERIAL]: '15',
        [METRIC]: '37',
        results: {
          hybrid: '3X (F-G)',
        },
      },
      {
        [IMPERIAL]: '15 1/2',
        [METRIC]: '39',
        results: {
          hybrid: '3X (F-G)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '45 - 47 1/2',
      [METRIC]: '114 - 121',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '12 1/2',
        [METRIC]: '31',
        results: {
          alpha: '3X',
          hybrid: '3X (A-B)',
        },
      },
      {
        [IMPERIAL]: '13',
        [METRIC]: '32',
        results: {
          alpha: '3X',
          hybrid: '3X (A-B)',
        },
      },
      {
        [IMPERIAL]: '13 1/2',
        [METRIC]: '34',
        results: {
          alpha: '3X',
          hybrid: '3X (C-E)',
        },
      },
      {
        [IMPERIAL]: '14',
        [METRIC]: '36',
        results: {
          alpha: '4X',
          hybrid: '4X (C-E)',
        },
      },
      {
        [IMPERIAL]: '15',
        [METRIC]: '37',
        results: {
          alpha: '4X',
          hybrid: '4X (C-E)',
        },
      },
      {
        [IMPERIAL]: '15 1/2',
        [METRIC]: '39',
        results: {
          hybrid: '4X (F-G)',
        },
      },
      {
        [IMPERIAL]: '16',
        [METRIC]: '40',
        results: {
          hybrid: '4X (F-G)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '48 -50 1/2',
      [METRIC]: '122 - 128',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '13',
        [METRIC]: '32',
        results: {
          alpha: '4X',
          hybrid: '4X (A-B)',
        },
      },
      {
        [IMPERIAL]: '13 1/2',
        [METRIC]: '34',
        results: {
          alpha: '4X',
          hybrid: '4X (A-B)',
        },
      },
      {
        [IMPERIAL]: '14',
        [METRIC]: '36',
        results: {
          alpha: '4X',
          hybrid: '4X (C-E)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '51 - 53 1/2',
      [METRIC]: '129 - 136',
    },
  },
];

export const BRA_SIZES_CONCEPT_IDS = {
  '1X': '9d40c2d0-7855-3c6e-8836-870e6c919edb',
  '1X (A-B)': '21f4e8fc-4e85-3e84-b428-cde9f2af8eaa',
  '1X (C-E)': '8c30a98a-4903-361d-9753-d85d6300d217',
  '1X (F-G)': '3f27e7cd-e9d0-39c4-8d17-665bcb9b8a90',
  '2X': '66050d1e-12d2-381a-9c75-a868204f683d',
  '2X (A-B)': '22083050-4a3f-33c4-b9fd-5ec3c10a84e3',
  '2X (C-E)': 'e8ecfcf6-fab6-3151-affe-ead96ca47273',
  '2X (F-G)': '95a4e1f2-591e-3582-aed2-700724cc6445',
  '2XL': '52b90480-7e00-301c-b4e3-5bef1a4bbbd4',
  '2XL (A-B)': '30171033-c992-342d-8b98-f745b6dd408d',
  '2XL (C-E)': 'd4003c0e-c3dc-31db-8b7b-3b94c506cc0e',
  '2XL (F-G)': 'a03ab6de-f01a-377d-896c-6372ba1cba81',
  '3X': '514f59e3-a0f4-3350-ad95-2ac180f6fd17',
  '3X (A-B)': 'f0a9ac88-b40e-3a9c-a56b-369718099fea',
  '3X (C-E)': 'c9d01d35-4e68-3d5e-94ce-ee8525a1bf5b',
  '3X (F-G)': '5ac75c69-9966-31f7-963c-c918429e27ca',
  '4X': '8b3a0329-fe8f-3d1f-b4a8-bed3f2536e1f',
  '4X (A-B)': '6f266453-c603-3dc1-84ed-3c456f175103',
  '4X (C-E)': '1dbae363-e676-3948-8c10-0ba348665146',
  '4X (F-G)': 'b8cd30fd-38a3-3ea8-a73d-a4131727155b',
  L: '2cd7b108-a281-3655-ba91-c00e97bd0d52',
  'L (A-B)': '57176e14-9e2e-37eb-8104-cf2c9ef0b60a',
  'L (C-E)': '6c964a36-7cf9-353f-aa54-272870121529',
  'L (F-G)': 'c0c4b345-67f5-3935-8dac-00ae695ad979',
  M: '138b81c1-900f-3f8d-8bf9-9ce2f3121a8e',
  'M (A-B)': '04922b82-0eb6-351a-8617-0a26a0e68602',
  'M (C-E)': 'd7d02052-16df-3d6f-b951-1eefa184388d',
  'M (F-G)': '4169d909-8c34-39f7-946b-2c383c667598',
  S: '73e5fd2f-df0d-3b2e-a84d-669bad0abf8a',
  'S (A-C)': 'a1f8fb3a-64e1-3c93-ac85-c5b572b457fa',
  'S (C-E)': '7b2fb5cc-c7d5-3889-9f48-518c4a02f264',
  'S (F-G)': '32812195-1374-3fe6-aeb5-79c2a98796a5',
  XL: '74478028-31c5-3a9d-9976-63a8c7182356',
  'XL (A-B)': 'c899cad3-ce56-3263-a1c7-c2fb48a8bb90',
  'XL (C-E)': '22f2f2a4-9850-35d7-854b-40614ea5c34a',
  'XL (F-G)': '3a3b96d4-f97a-3608-8476-1e700d6828a0',
  XS: 'dcd6ce26-6705-3c97-a22c-a563c5603333',
  'XS (A-C)': '36baec17-fe6f-3ab4-8f1e-8002e90616d6',
  'XS (D-E)': '64b044e3-cd6e-31e7-834a-231ac2de0e6d',
  'XS (F-G)': '272b3a0a-f911-3330-ae12-ac40788a23b6',
};
